import { Menu } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import styled from 'styled-components'

export const CardTitle = styled.div`
  color: rgba(0, 0, 0, 0.85);
  font-size: 30px;
  font-weight: 500;
  line-height: 38px;
  padding-bottom: 21px;
`

export const ModalTitle = styled.div`
  color: rgba(0, 0, 0, 0.85);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin-bottom: 0em;
`

export const DeleteOutlinedHover = styled(DeleteOutlined)`
  &:hover {
    color: #51b148;
  }
`

export const EditOutlinedHover = styled(EditOutlined)`
  &:hover {
    color: #51b148;
  }
`

export const NavWrapper = styled.div`
  width: 478px;
`

export const NavMenu = styled(Menu)`
  height: 48px;
  background: #51b148;
  border: 0;
  & > li.ant-menu-item.ant-menu-item-selected,
  & > li.ant-menu-item.ant-menu-item-selected a,
  & > li.ant-menu-item.ant-menu-item-active {
    background: #fff;
    color: #51b148;
  }
  & > li.ant-menu-item {
    vertical-align: top;
    top: 0px;
    margin: 0 !important;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
    background: #51b148;
    color: #fff;
    & > .anticon {
      font-size: 18px;
    }
  }
  & > li.ant-menu-item {
    padding: 0 20px !important;
  }
`

export const Content = styled.div`
  padding: 32px 40px;
`
